var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","clipped-left":"","clipped-right":"","color":_vm.color,"dark":_vm.dark}},[_vm._t("left-side"),_c('v-spacer'),_vm._t("right-side")],2)}
var staticRenderFns = []

export { render, staticRenderFns }